import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOpportunityLastSelectedState } from '~/types/opportunity/models'

const apiEntityPath = '/api/opportunitylastselectedstates'

export async function createOpportunityLastSelectedState(
  entity: IOpportunityLastSelectedState
) {
  const callingMn = createOpportunityLastSelectedState.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityLastSelectedState>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateOpportunityLastSelectedState(
  entityData: Partial<IOpportunityLastSelectedState>,
  id: TEntityId
) {
  const callingMn = updateOpportunityLastSelectedState.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOpportunityLastSelectedState =
    Partial<IOpportunityLastSelectedState>
  return httpPatchMerge<TPartialOpportunityLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOpportunityLastSelectedState(
  entityData: IOpportunityLastSelectedState
) {
  const callingMn = deleteOpportunityLastSelectedState.name
  const apiPath = apiEntityPath
  return httpDelete<IOpportunityLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}
